export const SPECS = {
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  ShouldSupportTimeSlotsInCheckout: 'specs.stores.ShouldSupportTimeSlotsInCheckout',
  AddOptionsToOrderItemName: 'specs.stores.AddOptionsToOrderItemName',
  ReportReasonForFastFlowRedirectBI: 'specs.stores.ReportReasonForFastFlowRedirectBI',
  UseSingleCustomerDetailsFormWithComposer: 'specs.stores.UseSingleCustomerDetailsFormWithComposer',
  ShouldForwardContactDetailsPickupFlow: 'specs.stores.ShouldForwardContactDetailsPickupFlow'
};
//# sourceMappingURL=SPECS.js.map